var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUspAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/award"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.23876 6L8.9965 10.6798C9.00499 10.7349 8.99794 10.7916 8.97631 10.8422C8.95467 10.8927 8.91948 10.9349 8.87543 10.9629C8.83138 10.991 8.78058 11.0036 8.72982 10.9991C8.67906 10.9946 8.63075 10.9732 8.59137 10.9378L6.8008 9.46293C6.71436 9.39206 6.60935 9.35377 6.50145 9.35377C6.39355 9.35377 6.28855 9.39206 6.20211 9.46293L4.40853 10.9372C4.36918 10.9726 4.32093 10.994 4.27023 10.9985C4.21953 11.003 4.16879 10.9904 4.12477 10.9624C4.08075 10.9345 4.04555 10.8924 4.02387 10.8419C4.00218 10.7914 3.99504 10.7349 4.0034 10.6798L4.76064 6",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 7C7.65685 7 9 5.65685 9 4C9 2.34315 7.65685 1 6 1C4.34315 1 3 2.34315 3 4C3 5.65685 4.34315 7 6 7Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspAward);
export default __webpack_public_path__ + "static/media/usp-award.7631f43e63d3d4325d44f6c1c8d5917f.svg";
export { ForwardRef as ReactComponent };